<!--
Folder
文件夹
-->


<template>
  <transition name="el-fade-in-linear">
    <div>
      <el-collapse-item title="文件夹" name="文件夹">
        <el-row>
          <el-col :span="24">
            <el-form :label-position="labelPosition" :model="folder" label-width="80px">
              <el-form-item label="尺寸">
                <el-radio-group v-model="folder['尺寸']">
                  <el-radio-button label="A4(31*22cm)">A4(31*22cm)</el-radio-button>
                  <el-radio-button label="B5(15*22cm)">B5(15*22cm)</el-radio-button>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="款式">
                <el-input v-model="folder['款式']" placeholder="请填写您选择的款式的描述"></el-input>
              </el-form-item>
              <el-form-item label="数量">
                <el-select v-model="folder['数量']" placeholder="数量">
                  <el-option label="单款1000个" value="单款1000个"></el-option>
                  <el-option label="两款各500个" value="两款各500个"></el-option>
                </el-select>
              </el-form-item>
              <el-button v-on:click="addEvent()">提交</el-button>
              <el-button v-on:click="clear()">清空</el-button>
            </el-form>
          </el-col>
        </el-row>
      </el-collapse-item>
    </div>
  </transition>
</template>
<script>
export default {
  name: "Folder",
  data() {
    return {
      forcollapse: ["allsame"],
      folder: {
        title: "文件夹"
      },
      labelPosition: "left"
    };
  },
  methods: {
    addEvent() {
      this.$root.add(this.folder);
    },
    clear() {
      this.$root.clearAlert();
      this.folder = {
        title: "文件夹"
      };
    }
  }
};
</script>
<style scoped>
</style>